<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <div class="mt-30">
        <!-- <div>
          <h4>{{chapter.moduletitle}}</h4>
          <div class="menter">
            <div class="chapter">
              <img :src="chapter.moduleimg" alt="" />
            </div>
            <div class="menter_left" v-html="chapter.moduledesc"></div>
          </div>
        </div> -->
        <div class="middel_center">
          <div
            class="center_list fdc"
            v-for="(item, index) in aboutUsInfo"
            :key="index"
          >
            <div class="center_pricute" v-if="index % 2 == 0">
              <img :src="item.moduleimg" alt="" />
              <span class="words">{{ item.moduletitle }}</span>
            </div>
            <div
              class="center_text color_2"
              v-else
              v-html="item.moduledesc"
            ></div>
            <div
              class="center_text color_1"
              v-if="index % 2 == 0"
              v-html="item.moduledesc"
            ></div>
            <div class="center_pricute" v-else>
              <img :src="item.moduleimg" alt="" />
              <span class="words">{{ item.moduletitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { aboutus } from "../../api/information";
  import commBanner from "../../common/commBanner";
  import titleHead from "../../common/titleHead";
  export default {
    components: { commBanner, titleHead },
    data() {
      return {
        headTitle: "广告服务",
        obj: {
          title: "广告服务",
          isShow: false,
          isColor: false,
          roleType:'',
          personalType:'',
          bannerUrl:'',
        },
        aboutUsInfo: [],
        chapter:{}
      };
    },
    created() {
      this.getAboutUsInfo();
      this.getMate();
      if(this.$store.state.user.userInfo != null){	
        this.obj.roleType = this.$store.state.user.userInfo.type;
        this.obj.personalType = 9;
      }
    },
    methods: {
      getAboutUsInfo() {
        aboutus({ type: 1 }).then((res) => {
          if(res.code == 0){
            this.aboutUsInfo = res.data;
            this.chapter = res.data[0];
          }
        });
      },
      getMate(){
        var metas = document.getElementsByTagName("meta"); 
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
     },
    },
  };
</script>
<style scoped>
  .mb-60 {
    margin-bottom: 60px;
  }
  .title_img {
    height: 25px;
  }
  h4 {
    color: #a6da5c;
    font-size: 18px;
  }
  .menter {
    margin-top: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #494b4d;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
  }
  /* .menter img {
    width: 30%;
    height: 230px;
  } */
  .chapter {
    width: 35%;
    overflow: hidden;
  }
  .chapter img {
    width: 100%;
    height: 250px;
    transition: all 0.6s;
  }
  .chapter img:hover{
    transform: scale(1.2);
  }
  .menter_left {
    margin: 0px 30px;
    font-size: 13px;
    width: 60%;
    display: flex;
  }
  .menter_left>>> p{
    width: 50%;
    margin-right: 20px;
  }
  .menter_right {
    margin-right: 20px;
    width: 50%;
    font-size: 13px;
  }
  .letter {
    margin-top: 20px;
    margin-right: 20px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
  .letter img:nth-child(1) {
    width: 273px;
    height: 22px;
  }
  .letter img:nth-child(2) {
    width: 412px;
    height: 32px;
    margin-top: 10px;
  }
  .middel_center {
    margin-top: 40px;
    width: 100%;
  }
  .center_pricute {
    width: 50%;
    height: 351px;
    overflow: hidden;
    position: relative;
  }

  .center_pricute img {
    width: 100%;
    height: 351px;
    cursor: pointer;
    transition: all 0.6s;
  }
  .center_pricute img:hover {
    transform: scale(1.2);
  }
  .words {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    position: absolute;
    left: 42%;
    top: 42%;
    margin-top:20px;
  }
  .center_text {
    width: 50%;
    padding: 15px 26px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    height: 351px;
    word-wrap:break-word;
    /* overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap; */
  }
  .conter_text >>>p>>>img{
    padding-bottom: 20px;
  }
  .color_1 {
    color: #169fac;
  }
  .color_2 {
    color: #1d5ac5;
  }
  .color_3 {
    color: #fa00a13b;
  }
  .color_4 {
    color: #70a01a;
  }
</style>0000



// WEBPACK FOOTER //
// src/view/other/advertising_services.vue